import { getUploadedImagePath } from '@nutastic/nutastic-react-app';

export const buildAuthorCredit = (primaryArtist, artistList) => {
    const { name: primaryArtistName } = primaryArtist;
    if (primaryArtist && primaryArtistName) {
        const namesList = [primaryArtistName];
        (artistList || []).forEach(artistObj => {
            if(artistObj !== null) {
                const { name } = artistObj;
                namesList.push(name);
            }
        });
        return namesList.join(", ");
    }
    return "N/A";
}

/**
 *
 * @param musicObjectList - object with references to music data
 * @param coverImage - image for the cover
 * @returns {{title: *, src: string, author: string, thumbnail: string}[]}
 */
const buildTracks = (musicObjectList, coverImage) => {
    return (musicObjectList || []).map(track => {
        const { title, field_2: audioFile, artist: artistObj = {}, artists = [], field_6: artistOverride } = track;
        return {
            title: title,
            src: getUploadedImagePath(audioFile),
            author: artistOverride ? artistOverride : buildAuthorCredit(artistObj, artists),
            thumbnail: getUploadedImagePath(coverImage)
        }
    })
};

export default buildTracks;
